import { onAuthStateChanged } from "firebase/auth";

import { auth } from "../firebase";

/**
 * Resolves once Firebase Auth has finished its initial state restore.
 * Returns the current user (or null if signed out).
 */
export function waitForAuthReady() {
  return new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub();
      resolve(user);
    });
  });
}
